module.exports = __webpack_public_path__ + "static/media/na.efac2847.svg";